import Star from './Star.js';

export default class ProductReviews {
  constructor(reviews) {
    this.reviews = reviews || 0;
    this.reviewsNode = document.createElement('div');

    this.init();
  }

  /**
   * Initialize ProductTile Reviews section
   */
  init() {
    this.reviewsNode.classList.add('ProductTileReviews');

    const numStars = this.reviews;

    for (let i = 0; i < 5; i++) {
      const star = new Star();
      if (numStars <= i) {
        this.reviewsNode.appendChild(star.setEmptyStar());
      } else if (numStars - i === 0.5) {
        this.reviewsNode.appendChild(star.setHalfStar());
      } else {
        this.reviewsNode.appendChild(star.setFullStar());
      }
    }
  }
}
